var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 56,
    viewBox: "0 0 42 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.408 54.6C12.698 47.578 0 30.56 0 21 0 9.402 9.402 0 21 0c11.594 0 21 9.402 21 21 0 9.56-12.797 26.578-18.408 33.6a3.305 3.305 0 0 1-5.184 0ZM21 28c3.86 0 7-3.14 7-7s-3.14-7-7-7-7 3.14-7 7 3.14 7 7 7Z",
    fill: "#FFC83E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 7.875,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v56H0z"
  })))));
};
export { SvgMapPin as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA0MiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE5XzM0NikiPgo8cGF0aCBkPSJNMTguNDA3OCA1NC42QzEyLjY5ODQgNDcuNTc4MSAwIDMwLjU1OTQgMCAyMUMwIDkuNDAxODcgOS40MDE4NyAwIDIxIDBDMzIuNTkzOCAwIDQyIDkuNDAxODcgNDIgMjFDNDIgMzAuNTU5NCAyOS4yMDMxIDQ3LjU3ODEgMjMuNTkyMiA1NC42QzIyLjI0NjkgNTYuMjczNCAxOS43NTMxIDU2LjI3MzQgMTguNDA3OCA1NC42Wk0yMSAyOEMyNC44NjA5IDI4IDI4IDI0Ljg2MDkgMjggMjFDMjggMTcuMTM5MSAyNC44NjA5IDE0IDIxIDE0QzE3LjEzOTEgMTQgMTQgMTcuMTM5MSAxNCAyMUMxNCAyNC44NjA5IDE3LjEzOTEgMjggMjEgMjhaIiBmaWxsPSIjRkZDODNFIi8+CjxjaXJjbGUgY3g9IjIxIiBjeT0iMjEiIHI9IjcuODc1IiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE5XzM0NiI+CjxyZWN0IHdpZHRoPSI0MiIgaGVpZ2h0PSI1NiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";